export const routeNames = {
    dashboardRoutes:[
        'dashboard',
        'teacherDashboard'
    ],
    masterRoutes:[
        'employeeList',
        'employeeCreate',
        'employeeEdit',
        'employeeDetail',
        'periodList',
        'periodCreate',
        'periodEdit',
        'gradeList',
        'gradeCreate',
        'gradeEdit',
        'holidayList',
        'holidayCreate',
        'holidayEdit',
        'holidayDetail',
        'paymentMethodList',
        'paymentMethodCreate',
        'paymentMethodDetail',
        'paymentMethodEdit',
        'teacherTypeList',
        'teacherTypeCreate',
        'teacherTypeEdit',
        'teacherTypeDetail',
        'appFormList',
        'appFormCreate',
        'appFormItems',
        'appFormDetail',
        'appFormEdit',
        'appFormEditItems',
        'shiftSetting',
        'shiftPatternList',
        'shiftPatternCreate',
        'shiftPatternEdit',
        'shiftPatternDetail',
        'leaveTypeList',
        'leaveTypeCreate',
        'leaveTypeEdit',
        'leaveTypeDetail',
        'positionList',
        'positionCreate',
        'positionEdit',
        'positionDetail',
        'paymentAttributeList',
        'paymentAttributeCreate',
        'paymentAttributeEdit',
        'paymentAttributeDetail',
        'leaveBalanceList',
        'leaveBalanceEdit',
    ],
    gradeRoutes : [
        'campusGradeList',
        'campusGradeCreate',
        'campusGradeEdit',
        'gradeFeeList',
        'gradeFeeCreate',
        'gradeFeeEdit',
        'gradeFeeDetail',
        'timetableMetaList',
        'timetableMetaCreate',
        'timetableMetaDetail',
        'timetableMetaEdit',
        'timetableList',
        'timetableCreate',
        'timetableDetail',
        'timetableEdit',
        'classList',
        'classCreate',
        'classEdit',
        'classDetail',
        'subjectList',
        'subjectCreate',
        'subjectEdit',
        'subjectDetail',
    ],
    teacherRoutes: [
        'attendanceTeacherList',
        'attendanceTeacherDetail',
        'attendanceTeacherEdit',
        'attendanceTeacherCreate',
        'subjectTeacher',
        'subjectTeacherList',
        'subjectTeacherCreate',
        'subjectTeacherEdit',
        'subjectTeacherDetail',
        'courseList',
        'courseCreate',
        'courseEdit',
        'courseDetail',
        'ChatMessageHistory',
        'chatRequestList',
        'assignmentList',
        'assignmentCreate',
        'assignmentEdit',
        'assignmentDetail',
        'teacherLeaveList',
        'teacherLeaveCreate',
        'teacherLeaveEdit',
        'teacherLeaveDetail',
        'teacherMonthlyAttendance',
        'ShiftAssign',
    ],
    studnetRoutes:[
        'parentList',
        'parentCreate',
        'parentEdit',
        'parentDetail',
        'studentList',
        'studentEdit',
        'studentPass',
        'studentFail',
        'studentCreate',
        'studentProfile',
        'examList',
        'examCreate',
        'examDetail',
        'examEdit',
        'gradingList',
        'ClassScoreSummary',
        'gradingCreate',
        'gradingDetail',
        'gradingEdit',
        'gradingImport',
        'attendanceStudentList',
        'attendanceStudentDetail',
        'attendanceStudentEdit',
        'attendanceStudentCreate',
        'attendanceRateList',
        'leaveList',
        'leaveCreate',
        'leaveEdit',
        'leaveDetail',
        'applicantList',
        'applicantDetail',
        'monthlyAttendance',
    ],
    financeRoutes: [
        'itemList',
        'itemCreate',
        'itemDetail',
        'itemEdit',
        'paymentRequestList',
        'paymentRequestDetail',
        'paymentList',
        'paymentCreate',
        'paymentDetail',
        'paymentEdit',
        'paymentCheckout',
        'transactionList',
        'transactionCreate',
        'transactionDetail',
        'transactionEdit',
        'salaryList',
        'salaryCreate',
        'salaryEdit',
        'salaryDetail',
        'enrollmentCreate',
        'SalaryChangesHistoryList',
        'skillList',
        'skillCreate',
        'skillEdit',
        'paymentAttributeDetailList',
        'paymentAttributeDetailCreate',
        'paymentAttributeDetailEdit',
        'payslipList',
        'payslipDetail',
    ],
    ferryRoutes: [
        'driverList',
        'driverCreate',
        'driverEdit',
        'driverDetail',
        'ferryCreate',
        'ferryList',
        'ferryEdit',
        'ferryDetail',
        'routeList',
        'routeCreate',
        'routeEdit',
        'routeDetail',
        'ferryPickupList',
        'ferryPickupDetail',
        'ferryPickupEdit',
        'dailyFerryList',
        'dailyFerryCreate',
        'dailyFerryEdit',
        'dailyFerryDetail',
        'ferryZoneList',
    ],
    libraryRoutes: [
        'bookList',
        'bookCreate',
        'bookDetail',
        'bookEdit',
        'libraryMemberList',
        'libraryMemberCreate',
        'libraryMemberDetail',
        'libraryMemberEdit',
        'checkoutList',
        'checkoutCreate',
        'checkoutDetail',
        'checkoutEdit',
        'damageLossesList',
        'damageLossesCreate',
        'damageLossesDetail',
        'damageLossesEdit',
        'categoryItems',
    ],
    noticeRoutes:[
        'noticeList',
        'noticeCreate',
        'noticeDetail',
        'noticeEdit',
    ],
    reportRoutes:[
        'transactionReport',
        'PassPercentage',
    ]
};
